import { PaletteOptions } from '@material-ui/core/styles/createPalette';
import { Color } from './color';
import { Intent } from './intent';

const sunrunColors = {
  blue: '#0073E0',
  green: '#038761',
  yellow: '#FFD35C',
  warningYellow: '#F7981C',
  red: '#CB2B51',
  lightBlue: '#E6F1FC',
  lightGreen: '#E6F6F2',
  lightWarningYellow: '#FEF5E9',
  lightRed: '#F6E1E9',
};

export const createSunrunPalette = (isDarkMode: boolean = false, useIntents: boolean = false): PaletteOptions => ({
  type: isDarkMode ? 'dark' : 'light',
  primary: { main: useIntents ? Color.PRIMARY_BLUE : sunrunColors.blue },
  secondary: { main: useIntents ? Intent.SUCCESS.textColor : sunrunColors.green },
  error: { main: useIntents ? Intent.ERROR.textColor : sunrunColors.red },
  warning: { main: useIntents ? Intent.WARNING.textColor : sunrunColors.warningYellow },
  success: { main: useIntents ? Intent.SUCCESS.textColor : sunrunColors.green },
  text: {
    primary: isDarkMode ? Color.WHITE : ( useIntents ? Color.BLACK_95 : '#41414D' ),
    secondary:  useIntents ? Color.BLACK_45 :'#B3B3B3',
  },
});
